import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ChevronRightIcon from 'components/material-symbol/icons/ChevronRight'

const useStyles = makeStyles(theme => ({
  navCard: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
    margin: 0,
    padding: theme.spacing(2, 2.5),
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E0E0E0',
    color: 'inherit',
    cursor: 'pointer',
    textAlign: 'left',
    font: 'inherit',
    fontFamily: 'inherit',
    appearance: 'none',
    WebkitAppearance: 'none',
    transition: 'background-color 0.2s ease, border-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#FAFBFC',
      borderColor: '#D0D0D0',
    },
  },
  navIconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: '#EBF0F2',
    flexShrink: 0,
  },
  navIcon: {
    fontSize: 22,
    color: '#172024',
  },
  navCopy: {
    flex: '1 1 auto',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(0.5),
  },
  navTitle: {
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: '#00205B',
    margin: 0,
  },
  navCaption: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    margin: 0,
  },
  navChevron: {
    color: '#9EA7B0',
    flexShrink: 0,
  },
}))

export default function IndexCard({
  title,
  caption,
  value,
  icon: Icon,
  onClick,
  testId = `student-mobile-nav-${value}`,
}) {
  const classes = useStyles()

  return (
    <Box
      className={classes.navCard}
      component="button"
      type="button"
      data-testid={testId}
      onClick={() => onClick(value)}
    >
      <Box className={classes.navIconWrap}>
        <Icon className={classes.navIcon} />
      </Box>
      <Box className={classes.navCopy}>
        <Typography className={classes.navTitle}>{title}</Typography>
        <Typography className={classes.navCaption}>{caption}</Typography>
      </Box>
      <ChevronRightIcon className={classes.navChevron} />
    </Box>
  )
}
